import { render, staticRenderFns } from "./Detail_newsDetail.vue?vue&type=template&id=5dd2f1ef&scoped=true"
import script from "./Detail_newsDetail.vue?vue&type=script&lang=js"
export * from "./Detail_newsDetail.vue?vue&type=script&lang=js"
import style0 from "./Detail_newsDetail.vue?vue&type=style&index=0&id=5dd2f1ef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd2f1ef",
  null
  
)

export default component.exports